import { AuthUser } from '../store/models/User';

export const decodeJwtManually = (token: string): AuthUser | null => {
  try {
    const [, payloadBase64] = token.split('.');
    if (!payloadBase64) {
      return null;
    }
    return JSON.parse(atob(payloadBase64));
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
};
